import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyBo9U8YHlvhlE_eKhXWc6Q__wa5_LIcW_8",
  authDomain: "aainmaculadabaloncesto.firebaseapp.com",
  projectId: "aainmaculadabaloncesto",
  storageBucket: "aainmaculadabaloncesto.appspot.com",
  messagingSenderId: "1040649936445",
  appId: "1:1040649936445:web:f3ac2c27060bb0c96b9454",
  measurementId: "G-RFYBRVRBG1"
};

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  export const auth = getAuth(app);
  export const db = getFirestore(app);



